import React from 'react';
import { ContentfulPage } from '../common/ContentfulPage';
import { contentfulPages } from '../../services/constants';

const PrivacyPolicyScreen = () => (
  <ContentfulPage contentfulKey={contentfulPages.PRIVACY_POLICY} />
);

export { PrivacyPolicyScreen };
